<script>
export default {
  computed: {
    isSettingsUser: function () {
      return this.$route.name === 'settings-user'
    }
  }
}
</script>
